import React, { useEffect } from "react";
import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  DatePickerToolbar,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ja from "date-fns/locale/ja";
import { format, isSaturday, isSunday, set } from "date-fns";

import { TextField } from "@mui/material";
import { useRecoilState } from "recoil";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { userState } from "../../../../states/userState";
import {
  backGroundColorCode,
  backgroundColor,
  foreColorCodePagination,
} from "../../../../commons/colors";

const styles = {
  mobiledialogprops: {
    ".MuiDatePickerToolbar-title": {
      fontSize: "1.5rem",
    },
    'div[class^="PrivatePickers"] div[class^="css-"]>span:nth-of-type(1)': {
      color: "rgba(255, 0, 0, 0.6)", // 日 = 赤
    },
    'div[class^="PrivatePickers"] div[class^="css-"]>span:nth-of-type(7)': {
      color: "rgba(0, 0, 255, 0.6)", // 土 = 青
    },
  },
  paperprops: {
    'div[class^="PrivatePickers"] div[class^="css-"]>span:nth-of-type(1)': {
      color: "rgba(255, 0, 0, 0.6)", // 日 = 赤
    },
    'div[class^="PrivatePickers"] div[class^="css-"]>span:nth-of-type(7)': {
      color: "rgba(0, 0, 255, 0.6)", // 土 = 青
    },
  },
};

const SingleDatePicker = (props) => {
  const {
    setCurrentDate,
    currentDate,
    order,
    setError,
    compDate,
    label,
    disabled,
    setCompDate,
  } = props;
  // const [calendar, setCalendar] = useRecoilState(calendarState);
  const [user, setUser] = useRecoilState(userState);
  const theme = useTheme();
  // 768px以下の画面幅でtrueを返す
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const CustomDay = ({ day, selected, inCurrentMonth, ...other }) => {
    // `inCurrentMonth` を除外して、DOM 要素に渡されないようにする
    const customStyle = {
      ...(isSunday(day) && { color: "red" }), // 日曜日は赤色
      ...(isSaturday(day) && { color: "blue" }), // 土曜日は青色
    };

    return (
      <PickersDay
        {...other}
        day={day}
        selected={selected}
        sx={{
          ...customStyle,
        }}
      />
    );
  };
  useEffect(() => {
    if (user.filters.fromDate === "") {
      setCurrentDate(null);
    }
  }, [user.filters.fromDate]);
  const handlecurrentDateChange = (newDate) => {
    if (order === "From") {
      handleFromDateChange(newDate);
    } else {
      handleToDateChange(newDate);
    }
  };
  const handleFromDateChange = (newDate) => {
    console.log("newDate", newDate);
    if (newDate > compDate) {
      //setError('開始日は終了日より前に設定してください');
      setCurrentDate(newDate);
      const year = newDate.getFullYear(); //開始日の年
      const month = newDate.getMonth(); //開始日の月
      const lastDayOfMonth = new Date(year, month + 1, 0); //開始年月の月末
      // newDateの月の月末日を設定
      // const correctToDate = new Date(year, month, lastDayOfMonth);
      // console.log("currentDate", currentDate);
      setCompDate(lastDayOfMonth);
      // setCalendar({ ...calendar, overtimeToDate: correctToDate });
    } else {
      setCurrentDate(newDate); //開始日をセットしている
      if (
        newDate.getMonth() !== compDate.getMonth() ||
        newDate.getFullYear() !== compDate.getFullYear()
      ) {
        // newDateの年と月を使用して、月末の日付を求める
        const year = newDate.getFullYear(); //開始日の年
        const month = newDate.getMonth(); //開始日の月
        const lastDayOfMonth = new Date(year, month + 2, 0); //開始年月の月末
        // newDateの月の月末日を設定
        // const correctToDate = new Date(year, month, lastDayOfMonth);
        setCompDate(lastDayOfMonth); //終了日をセットしている
        // setCalendar({ ...calendar, overtimeToDate: correctToDate });
      }
    }
    setError("");
  };

  const handleToDateChange = (newDate) => {
    if (compDate > newDate) {
      setError("終了日は開始日より後に設定してください");
      setCurrentDate(compDate);
    } else {
      setError("");
      setCurrentDate(newDate);
    }
  };
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={ja}
      dateFormats={{ monthAndYear: "yyyy年 MM月" }}
      localeText={{
        previousMonth: "前月を表示", // < のツールチップ
        nextMonth: "次月を表示", // > のツールチップ
        cancelButtonLabel: "キャンセル", // スマホ画面のCANCELボタン
        okButtonLabel: "選択", // スマホ画面のOKボタン
      }}
    >
      <div>
        <div>
          {/* <div className= "CautionMessage">日付の範囲を絞って実行してください</div> */}
          <DatePicker
            disabled={disabled}
            label={order === "From" ? `${label}MIN` : `${label}MAX`}
            // value={currentDate}
            value={currentDate === "" ? null : currentDate}
            inputFormat="yyyy年MM月dd日" //選択済みの日付の表示
            mask="____年__月__日"
            onChange={handlecurrentDateChange}
            sx={{
              width: isIphone ? "95px" : isMobile ? "95px" : "136px",
              borderRadius: "5px",
              backgroundColor: backGroundColorCode(user?.mode ?? "lite"),
              "& input": {
                paddingTop: 0,
                paddingBottom: 0,
                // paddingLeft: "14px",
                paddingLeft: isIphone ? "5px" : isMobile ? "14px" : "14px",
                height: "38px",
                fontSize: isIphone ? "13px" : isMobile ? "13px" : "14px",
                // backgroundColor: "black",
                color: foreColorCodePagination(user?.mode ?? "lite"),
              },
              "& label": {
                color: foreColorCodePagination(user?.mode ?? "lite"),
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                inputProps={{
                  ...params.inputProps,
                  placeholder: "****年**月**日", //プレースホルダー（フォーカスを合わせたときに薄く表示される入力例）
                }}
                // InputLabelProps={{ shrink: true }}
              />
            )}
            slotProps={{ textField: { InputLabelProps: { shrink: true } } }}
            slots={{
              day: CustomDay,
              toolbar: CustomDatePickerToolbar,
            }}
            DialogProps={{ sx: styles.mobiledialogprops }} // スマホ画面の左上 選択中日付表示 文字の大きさ調整
            PaperProps={{ sx: styles.paperprops }} // 見だしの "土" "日" 表示色調整
            //displayStaticWrapperAs="mobile"
            toolbarFormat="yyyy年MM月dd日"
            toolbarTitle="日付選択"
          />
        </div>
      </div>
    </LocalizationProvider>
  );
};
const CustomDatePickerToolbar = (props) => {
  const { date, changeYear, changeMonth, isLandscape, onChange, ...other } =
    props;
  return (
    <DatePickerToolbar
      toolbarFormat="yyyy年MM月" // スマホ用の画面で出るツールバーの順番を整備
      isLandscape={isLandscape}
      onChange={onChange}
      value={date}
      view={date}
      {...other}
    />
  );
};
export default SingleDatePicker;
